import React, { Component } from "react";
import { connect } from "react-redux";

import ResetPassword from "../auth/ResetPassword";
import Layout from "../layout";
import history from "../../history";

class ResetPage extends Component {
  componentDidMount() {
    if (this.props.auth.isSignedIn) {
      history.push("/welcome");
    }
  }
  render() {
    return (
      <Layout title="Create New Password">
        <ResetPassword />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps)(ResetPage);
